import moment from 'moment';

export const getSuggestionsForCurrentWeek = () => {
  const currentWeek = moment().isoWeek();
  const weekKey = String(currentWeek);

  const suggestions = defaultSuggestionsByWeek[weekKey] ?? [];
  const shuffled = [...suggestions].sort(() => Math.random() - 0.5);

  return shuffled.slice(0, 5);
};

export const defaultSuggestionsByWeek = {
  1: [
    'New Year',
    "New Year's Resolutions",
    'Science',
    'Opinion',
    'Martin Luther King, Jr',
    'Animals',
    'American Revolution',
    'Social Media',
    'Geography',
    'New Years Traditions',
    'Ancient Egypt',
    'Resolutions',
    'Goal Setting',
    'Olympics',
    'Winter',
    'Energy',
    'Video Games',
  ],
  2: [
    'New Year',
    'Science',
    'Martin Luther King, Jr',
    'Snow',
    'Opinion',
    "New Year's Resolutions",
    'Social Media',
    'Space',
    'Animals',
    'American Revolution',
    'Winter',
    'Wildfires',
    'Olympics',
    'Technology',
    'Weather',
    'Poetry',
    'Mlk',
    'Sports',
    'Video Games',
    'Civil Rights',
  ],
  3: [
    'Martin Luther King, Jr',
    'Wildfires',
    'Tiktok',
    'Science',
    'Inauguration',
    'Opinion',
    'Animals',
    'Social Media',
    'Olympics',
    'Sports',
    'Civil Rights',
    'Poetry',
    'Space',
    'Argumentative Text',
    'Lunar New Year',
    'Technology',
    'Video Games',
  ],
  4: [
    'Martin Luther King, Jr',
    'Lunar New Year',
    'Science',
    'Tiktok',
    'Wildfires',
    'Inauguration',
    'Opinion',
    'Animals',
    'Chinese New Year',
    'Social Media',
    'Olympics',
    'Space',
    'Technology',
    'Video Games',
    'Civil Rights',
    'Argumentative Text',
    'Sports',
  ],
  5: [
    'Lunar New Year',
    'Chinese New Year',
    'Science',
    'Groundhog Day',
    'Animals',
    'Opinion',
    'Social Media',
    'Video Games',
    'Olympics',
    'Sports',
    'Wildfires',
    'Space',
    'Argumentative Text',
    'Tiktok',
    'Valentines Day',
    'American Revolution',
    'Super Bowl',
    'Poetry',
    'Civil Rights',
    'Football',
  ],
  6: [
    'Super Bowl',
    'Valentines Day',
    'Science',
    'Groundhog Day',
    'Animals',
    'Olympics',
    'Social Media',
    'Opinion',
    'Football',
    'Lunar New Year',
    'Space',
    'Video Games',
    'Ruby Bridges',
    'Civil Rights',
    'Technology',
    'Sports',
    'Music',
    'Rosa Parks',
    'Weather',
  ],
  7: [
    'Valentines Day',
    'Presidents Day',
    'Science',
    'Opinion',
    'Super Bowl',
    'Olympics',
    'Animals',
    'Video Games',
    'Social Media',
    'Space',
    'American Revolution',
    'Poetry',
    'Geography',
    'Civil Rights',
    'Technology',
  ],
  8: [
    'Science',
    'Presidents Day',
    'Opinion',
    'Animals',
    'Social Media',
    'Video Games',
    'Poetry',
    'Space',
    'Olympics',
    'Technology',
    'Cell Phones',
    'Argumentative Text',
    'Weather',
    'Sports',
    'American Revolution',
    'Civil Rights',
    'Civil War',
    'Harlem Renaissance',
    'Ruby Bridges',
    'Geography',
  ],
  9: [
    'Science',
    'Opinion',
    'Animals',
    'Video Games',
    'Ramadan',
    'Olympics',
    'Sports',
    'Social Media',
    'Poetry',
    'Civil War',
    'Space',
    'Technology',
    'American Revolution',
    'Weather',
    'Soccer',
    'Civil Rights',
    'Geography',
    'Fiction',
    'Argument',
    'Basketball',
    'Dogs',
  ],
  10: [
    "Women's History Month",
    'Science',
    'Ramadan',
    'Opinion',
    'Animals',
    'Mardi Gras',
    'Video Games',
    'Sports',
    'Social Media',
    'Poetry',
    'Olympics',
    'Fiction',
    'Space',
    'St Patricks Day',
    'Civil War',
    'Technology',
    'Basketball',
    'Soccer',
    'Spring',
    'American Revolution',
  ],
  11: [
    'St Patricks Day',
    'Science',
    'Animals',
    "Women's History Month",
    'Pi Day',
    'Opinion',
    'Daylight Savings',
    'Video Games',
    'Poetry',
    'Spring',
    'Olympics',
    'Sports',
    'Space',
    'Social Media',
    'March Madness',
    'Soccer',
    'Lunar Eclipse',
  ],
  12: [
    'St Patricks Day',
    'Spring',
    'Science',
    'March Madness',
    'Animals',
    'Opinion',
    'Olympics',
    'Space',
    'Video Games',
    'Social Media',
    "Women's History Month",
    'Sports',
    'Poetry',
    'Weather',
    'American Revolution',
    'Civil War',
    'Basketball',
    'Spring Break',
  ],
  13: [
    'Science',
    'Spring',
    'Poetry',
    'Animals',
    'Opinion',
    'Sports',
    'March Madness',
    'Social Media',
    'Cesar Chavez',
    'Video Games',
    'Olympics',
    'Civil War',
    'Space',
    'Basketball',
    'Soccer',
    'American Revolution',
    'Weather',
    "Women's History Month",
    'Fiction',
    'April Fools Day',
    'Cell Phones',
    'Music',
    'Technology',
  ],
  14: [
    'April Fools Day',
    'Science',
    'Poetry',
    'Spring',
    'Animals',
    'Earth Day',
    'Opinion',
    'Sports',
    'Video Games',
    'Civil War',
    'Space',
    'Olympics',
    'Social Media',
    'Cesar Chavez',
    'Easter',
    'Geography',
    'Soccer',
    'Basketball',
    'American Revolution',
    'Weather',
  ],
  15: [
    'Science',
    'Earth Day',
    'Poetry',
    'Easter',
    'Animals',
    'Spring',
    'Opinion',
    'Sports',
    'Civil War',
    'Olympics',
    'Video Games',
    'Space',
    'Social Media',
    'Weather',
    'Cold War',
    'Tariffs',
    'American Revolution',
    'Geography',
    'Technology',
    'Soccer',
    'Basketball',
  ],
  16: [
    'Earth Day',
    'Easter',
    'Science',
    'Poetry',
    'Animals',
    'Titanic',
    'Opinion',
    'Space',
    'Video Games',
    'Spring',
    'Civil War',
    'Sports',
    'Olympics',
    'Social Media',
    'Soccer',
    'Weather',
    'Minecraft',
    'Cold War',
    'Tariffs',
    'Geography',
    'American Revolution',
  ],
  17: [
    'Earth Day',
    'Science',
    'Poetry',
    'Animals',
    'Video Games',
    'Civil War',
    'Opinion',
    'Sports',
    'Social Media',
    'Olympics',
    'Space',
    'Spring',
    'Cold War',
    'Geography',
    'Soccer',
    'Minecraft',
    'American Revolution',
  ],
  18: [
    'Cinco De Mayo',
    'Science',
    'Animals',
    'Poetry',
    'Civil War',
    'May Day',
    'Olympics',
    'Opinion',
    'Sports',
    'Space',
    'Earth Day',
    'Cold War',
    'Video Games',
    'Soccer',
    'Geography',
    'Summer',
    'American Revolution',
    'Social Media',
    'World War 2',
    'Weather',
    'Music',
  ],
  19: [
    'Cinco De Mayo',
    'Science',
    'Mothers Day',
    'Animals',
    'Summer',
    'Civil War',
    'Space',
    'Video Games',
    'Soccer',
    'Sports',
    'Cold War',
    'Poetry',
    'Opinion',
    'Olympics',
    'Geography',
    'American Revolution',
    'Food',
  ],
  20: [
    'Science',
    'Summer',
    'Memorial Day',
    'Civil War',
    'Animals',
    'Sports',
    'Video Games',
    'Poetry',
    'Olympics',
    'Space',
    'Opinion',
    'Geography',
    'Soccer',
    'Cold War',
    'Greek Mythology',
    'Music',
    'Vietnam War',
    'World War 2',
    'Minecraft',
    'Current Events',
    'Social Media',
  ],
  21: [
    'Memorial Day',
    'Summer',
    'Science',
    'Civil War',
    'Animals',
    'Sports',
    'Video Games',
    'Poetry',
    'Space',
    'Opinion',
    'Olympics',
    'American Revolution',
    'Geography',
    'Soccer',
    'Minecraft',
    'Weather',
    'Vietnam War',
    'Cold War',
    'Social Media',
    'Ancient Rome',
    'Greek Mythology',
  ],
  22: [
    'Memorial Day',
    'Summer',
    'Science',
    'Sports',
    'Animals',
    'Space',
    'Olympics',
    'Civil War',
    'Basketball',
    'Social Media',
    'Soccer',
    'Ancient Greece',
    'Geography',
    'Video Games',
    'Civil Rights',
    'American Revolution',
    'Dogs',
    'Fiction',
    'Minecraft',
    'Poetry',
    'Ancient Rome',
  ],
  23: [
    'Summer',
    'Science',
    'Animals',
    'Olympics',
    'Sports',
    'Civil War',
    'Space',
    'Opinion',
    'Video Games',
    'Geography',
    'American Revolution',
    'Soccer',
    'Basketball',
    'Ancient Rome',
    'Social Media',
    'Back To School',
    'Health',
    'Artificial Intelligence',
  ],
  24: [
    'Summer',
    'Science',
    'Olympics',
    'Animals',
    'Sports',
    'Video Games',
    'Space',
    'Back To School',
    'Flag Day',
    'Geography',
    'Technology',
    'Soccer',
    'Civil War',
    'AI',
    'Labubu',
    'Poetry',
    'Basketball',
    'American Revolution',
    'Ancient Rome',
  ],
  25: [
    'Summer',
    'Science',
    'Sports',
    'Animals',
    'Olympics',
    'Soccer',
    'Back To School',
    'Graphic Organizers',
    'Geography',
    'Civil War',
    'Video Games',
    'Harlem Renaissance',
    'Opinion',
    'Dogs',
    'Space',
    'Baseball',
    'AI',
    'Ancient Rome',
    'History',
  ],
  26: [
    'Summer',
    'Science',
    'Animals',
    'Soccer',
    'Sports',
    'Harlem Renaissance',
    'Video Games',
    'Olympics',
    'Back To School',
    'Space',
    'Geography',
    'Poetry',
    'Social Media',
    'AI',
    '4Th Of July',
    'Energy',
    'American Revolution',
    'Basketball',
    'What Is Energy',
    'Iran',
    'Football',
  ],
  27: [
    'Science',
    'Fourth Of July',
    'Soccer',
    'Independence Day',
    'Summer',
    'Back To School',
    'Sports',
    'Animals',
    'Harlem Renaissance',
    'Geography',
    'Video Games',
    'Social Media',
    'Olympics',
    'Basketball',
    'American Revolution',
    'Greek Mythology',
    'Math',
    'Food',
    'AI',
    'Technology',
    'Dogs',
  ],
  28: [
    'Animals',
    'Science',
    'Olympics',
    'Back To School',
    'Sports',
    'Soccer',
    'Space',
    'Summer',
    'Dogs',
    'Geography',
    'Video Games',
    'Football',
    'Roblox',
    'Basketball',
    'Social Media',
    'Music',
    'Opinion',
    'Sharks',
    'Harlem Renaissance',
    'Fiction',
    'Weather',
    'Capybara',
  ],
  29: [
    'Back To School',
    'Science',
    'Animals',
    'Olympics',
    'Sports',
    'Summer',
    'Soccer',
    'Minecraft',
    'Video Games',
    'Geography',
    'Social Media',
    'AI',
    'Fiction',
    'Dogs',
    'Identity',
    'Ancient Egypt',
    'Weather',
    'Capybara',
    'Football',
    'Sharks',
    'Space',
    'Main Idea',
  ],
  30: [
    'Back To School',
    'Animals',
    'Soccer',
    'Science',
    'Olympics',
    'Sports',
    'Summer',
    'Geography',
    'Math',
    'American Revolution',
    'Football',
    'Poetry',
    'Minecraft',
    'Dogs',
    'Opinion',
    'Spanish',
    'AI',
    'Space',
    'History',
    'Video Games',
    'Fiction',
    'Sharks',
    'Civil War',
    'Capybara',
  ],
  31: [
    'Back To School',
    'Geography',
    'Olympics',
    'Maps',
    'Science',
    'Technology',
    'Math',
    'Sports',
    'Soccer',
    'Animals',
    'AI',
    'Landforms',
    'Fiction',
    'Summer',
    'Scientific Method',
    'Dogs',
    'Identity',
    'Spanish',
    'Space',
    'Labubu',
    'Football',
    'Labor Day',
    'Native American',
    'Greek Mythology',
  ],
  32: [
    'Back To School',
    'Geography',
    'Olympics',
    'Science',
    'Maps',
    'Graphic Organizers',
    'American Revolution',
    'Scientific Method',
    'Sports',
    '5 Themes Of Geography',
    'Culture',
    'Technology',
    'Math',
    'AI',
    'Matter',
    'Community',
    'Animals',
    'Economics',
    'Mesopotamia',
    'Poetry',
    'Current Events',
  ],
  33: [
    'Back To School',
    'Science',
    'Geography',
    'Olympics',
    'Growth Mindset',
    'Scientific Method',
    'Culture',
    'AI',
    'Sports',
    'Math',
    'Animals',
    'Fiction',
    'First Day Of School',
    'Identity',
    'Matter',
    'Current Events',
    'Soccer',
    'American Revolution',
    'Music',
    'Labubu',
    'Maps',
    'School',
    '5 Themes Of Geography',
    'Cells',
  ],
  34: [
    'Back To School',
    'Science',
    'Geography',
    'Scientific Method',
    'Olympics',
    'Math',
    'Growth Mindset',
    'Animals',
    'Sports',
    'AI',
    'Culture',
    'Buddy Benches',
    'Identity',
    'Theme',
    'Fiction',
    'Matter',
    'Labor Day',
    'Video Games',
    'Maps',
    'Music',
    'Empathy',
    'American Revolution',
    'Current Events',
    'Cell Phones',
  ],
  35: [
    'Back To School',
    'Olympics',
    'Geography',
    'Labor Day',
    '9/11',
    'Animals',
    'Science',
    'Energy',
    'Identity',
    'Growth Mindset',
    'Scientific Method',
    'Spanish',
    'Math',
    'Space',
    'Ecosystems',
    'Fiction',
    'Main Idea',
    'Refugee',
    'Health',
    'First Day Of School',
    'Water Cycle',
    'Point Of View',
    'Cars',
    'Mesopotamia',
    'AI',
    'Empathy',
    'Video Games',
    'Music',
    'Maps',
    'Culture',
    'Sports',
    'Technology',
    'Soccer',
    'Current Events',
    'Dogs',
    'Theme',
  ],
  36: [
    '9/11',
    'Olympics',
    'Back To School',
    'Science',
    'Geography',
    'Labor Day',
    'Animals',
    'Sports',
    'Matter',
    'Growth Mindset',
    'Video Games',
    'Cell Phones',
    'Soccer',
    'Election',
    'Fiction',
    'Hispanic Heritage',
    'Football',
    'Scientific Method',
    'Main Idea',
    'Identity',
    'Culture',
    'Technology',
    'Native Americans',
  ],
  37: [
    'Olympics',
    'Science',
    'Back To School',
    'History Of 9/11',
    'Geography',
    'Friday The 13Th',
    'Animals',
    'Sports',
    'Election',
    'Video Games',
    'Fiction',
    'Debate',
    'National Hispanic Heritage Month',
    'Main Idea',
    'Football',
    'Patriot Day',
  ],
  38: [
    'Science',
    'Olympics',
    'National Hispanic Heritage Month',
    'Geography',
    'Constitution Day',
    'Back To School',
    'Animals',
    'Video Games',
    'Sports',
    'Main Idea',
    'Hispanic',
    'Soccer',
    'Election',
    'Fiction',
    'Fall',
    'Matter',
    'Mesopotamia',
    'Music',
    'Scientific Method',
    'Mexican Independence Day',
    'Poetry',
  ],
  39: [
    'Science',
    'Olympics',
    'Geography',
    'National Hispanic Heritage Month',
    'Halloween',
    'Animals',
    'Fall',
    'Back To School',
    'Election',
    'Sports',
    'Main Idea',
    'Video Games',
    'Fiction',
    'American Revolution',
    'Hurricane',
    'Theme',
    'Soccer',
    'Music',
    'Mesopotamia',
    'Ancient Egypt',
    'Matter',
    'Space',
    'Opinion',
  ],
  40: [
    'Halloween',
    'Science',
    'Hurricane',
    'Olympics',
    'Geography',
    'Fall',
    'Election',
    'Animals',
    'Rosh Hashanah',
    'Soccer',
    'Video Games',
    'Sports',
    'Fiction',
    'American Revolution',
    'Back To School',
    'Poetry',
    'Space',
    'National Hispanic Heritage Month',
    'Mesopotamia',
    'Main Idea',
    'Football',
    'Theme',
  ],
  41: [
    'Halloween',
    'Science',
    'Election',
    'Olympics',
    'Indigenous People Day',
    'Animals',
    'Geography',
    'Indigenous',
    'Main Idea',
    'Mesopotamia',
    'Sports',
    'Video Games',
    'Voting',
    'Christopher Columbus',
    'Opinion',
    'American Revolution',
    'Electoral College',
    'Theme',
  ],
  42: [
    'Halloween',
    'Science',
    'Election',
    'Indigenous People Day',
    'Hurricane',
    'Animals',
    'Olympics',
    'Geography',
    'Columbus Day',
    'Day Of The Dead',
    'Voting',
    'Electoral College',
    'Sports',
    'Dia De Los Muertos',
    'Main Idea',
    'Mesopotamia',
    'Opinion',
    'American Revolution',
    'Fall',
    'Theme',
    'Space',
    'Christopher Columbus',
  ],
  43: [
    'Halloween',
    'Election',
    'Science',
    'Day Of The Dead',
    'Electoral College',
    'Dia De Los Muertos',
    'Voting',
    'Olympics',
    'Animals',
    'History Of Halloween',
    'Geography',
    'Main Idea',
    'Sports',
    'Poetry',
    'Hurricane',
    'Fall',
    'American Revolution',
    'Mesopotamia',
    'Opinion',
    'Diwali',
    'Video Games',
    'Ancient Egypt',
  ],
  44: [
    'Halloween',
    'Election',
    'Day Of The Dead',
    'Dia De Los Muertos',
    'Voting',
    'History Of Halloween',
    'Electoral College',
    'Diwali',
    'Science',
    'Thanksgiving',
    'Veterans Day',
    'Election Day',
    'Halloween Candy',
    'Olympics',
    'Animals',
    'Geography',
    'Poetry',
    'Sports',
    'Opinion',
    'Main Idea',
    'American Revolution',
  ],
  45: [
    'Election',
    'Veterans Day',
    'Thanksgiving',
    'Voting',
    'Election Day',
    'Electoral College',
    'Science',
    'Animals',
    'Olympics',
    'Veterans',
    'Opinion',
    'Native American',
    'Poetry',
    'Geography',
    'Video Games',
    'Sports',
    'Soccer',
    'Social Media',
    'Main Idea',
  ],
  46: [
    'Thanksgiving',
    'Veterans Day',
    'Science',
    'Animals',
    'Olympics',
    'Opinion',
    'Sports',
    'Video Games',
    'Veterans',
    'Social Media',
    'Native American',
    'Ancient Egypt',
    'Geography',
    'Poetry',
    'American Revolution',
    'Main Idea',
    'Space',
    'Soccer',
  ],
  47: [
    'Thanksgiving',
    'Science',
    'First Thanksgiving',
    'Christmas',
    'Animals',
    'Olympics',
    'Thanksgiving (United States)',
    'Native American',
    'Video Games',
    'Ancient Egypt',
    'Opinion',
    'Space',
    'Sports',
    'Gratitude',
    'Soccer',
    'Geography',
    'Poetry',
    'Weather',
    'Social Media',
    'Main Idea',
  ],
  48: [
    'Thanksgiving',
    'Christmas',
    'First Thanksgiving',
    'Science',
    'Social Media',
    'Winter',
    'Gratitude',
    'American Revolution',
    'Olympics',
    'Animals',
    'Black Friday',
    'Opinion',
    'Holidays',
    'Geography',
    'Sports',
    'History Of Thanksgiving',
    'Space',
    'Ancient Egypt',
    'Main Idea',
  ],
  49: [
    'Christmas',
    'Winter',
    'Science',
    'Holidays',
    'Social Media',
    'Pearl Harbor',
    'Animals',
    'Holidays Around The World',
    'Opinion',
    'Sports',
    'Video Games',
    'Olympics',
    'American Revolution',
    'Ancient Egypt',
    'Weather',
    'Poetry',
    'Main Idea',
    'December',
    'Space',
    'Geography',
    'Soccer',
  ],
  50: [
    'Christmas',
    'Winter',
    'Holidays',
    'Science',
    'Holidays Around The World',
    'Winter Holidays',
    'Animals',
    'Opinion',
    'Hanukkah',
    'Social Media',
    'American Revolution',
    'Syria',
    'Poetry',
    'Winter Solstice',
    'Sports',
    'Ancient Egypt',
    'Video Games',
    'Space',
    'Kwanzaa',
    'History Of Christmas',
    'Geography',
  ],
  51: [
    'Christmas',
    'Holidays',
    'Winter',
    'Science',
    'New Years',
    'Winter Holidays',
    'Holidays Around The World',
    'Winter Solstice',
    'History Of Christmas',
    'Hanukkah',
    'Kwanzaa',
    'Animals',
    'American Revolution',
    'Sports',
    'Opinion',
    'Olympics',
    'Video Games',
    'Social Media',
    'Ancient Egypt',
    'Poetry',
    'Geography',
    'Space',
  ],
  52: [
    'New Year',
    'Christmas',
    'Olympics',
    'Science',
    "New Year's Resolutions",
    'Soccer',
    'Back To School',
    'Martin Luther King, Jr',
    'Basketball',
    'Weather',
    'Space',
    'Fiction',
    'Civil Rights',
    'Friendship',
    'Technology',
    'Ancient Civilizations',
    'Harlem Renaissance',
    'American Revolution',
    'Music',
  ],
  53: [
    'New Year',
    'Christmas',
    'Olympics',
    'Science',
    "New Year's Resolutions",
    'Soccer',
    'Back To School',
    'Martin Luther King, Jr',
    'Basketball',
    'Weather',
    'Space',
    'Fiction',
    'Civil Rights',
    'Friendship',
    'Technology',
    'Ancient Civilizations',
    'Harlem Renaissance',
    'American Revolution',
    'Music',
  ],
};
